import data from "../../utils/constants/data.json";
import useFilters from "../../utils/custom-hooks/useFilters";
import CommonComponent from "../common-component/CommonComponent";

const ProjectsComponent = () => {
    const { projectsData } = data;

    const filters = useFilters(projectsData);

    const projectsLayout = <CommonComponent items={filters} />;

    return projectsLayout;
};

export default ProjectsComponent;
